export default "__VITE_ASSET__BwDmLp8R__"